import * as React from 'react';
import { Link } from 'react-router-dom';
import { BannerStyle } from '@built/design-system/types/Banner/Banner';

import { AuthError } from '../types';
import Notification from '../containers/Notification';
import l10n from '@built/i18n';

export function contactSupport() {
  return (
    <React.Fragment>
      {l10n.t(
        'ErrorNotifications:contactSupport',
        'If you have any questions or concerns, contact'
      )}
      <Link to="mailto:support@getbuilt.com"> support@getbuilt.com</Link>.
    </React.Fragment>
  );
}

export function unknownError(className = '') {
  return (
    <Notification type="danger" title="Oops!" className={className}>
      <p>
        {l10n.t(
          'ErrorNotifications:unknownError',
          "Something happened that we didn't expect. Please try again in a few minutes. "
        )}
        {contactSupport()}
      </p>
    </Notification>
  );
}

export function genericError(
  error: AuthError,
  type: BannerStyle = 'danger',
  includeSupport = true,
  className = ''
) {
  return (
    <Notification type={type} title={error.title!} className={className}>
      <p>
        {error.message} {includeSupport && contactSupport()}
      </p>
    </Notification>
  );
}

export function invalidCredentialsError(authError: AuthError) {
  return (
    <Notification type="danger" title={authError.title!}>
      <p>
        {authError.message +
          ' ' +
          l10n.t(
            'ErrorNotifications:invalidCredentials',
            'For your security, your account will be locked after too many failed login attempts.'
          )}
      </p>
    </Notification>
  );
}

export function accountDisabledError(authError: AuthError, className = '') {
  return (
    <Notification type="danger" title={authError.title!} className={className}>
      <p>
        {authError.message +
          ' ' +
          l10n.t(
            'ErrorNotifications:accountDisabled',
            'For assistance and more information, contact'
          )}
        <Link to="mailto:support@getbuilt.com"> support@getbuilt.com</Link>.
      </p>
    </Notification>
  );
}

export function accountExpiredError(authError: AuthError, className = '') {
  return (
    <Notification type="danger" title={authError.title!} className={className}>
      <p>
        {authError.message +
          ' ' +
          l10n.t(
            'ErrorNotifications:accountExpired',
            'To reactivate your account, please contact'
          )}
        <Link to="mailto:support@getbuilt.com"> support@getbuilt.com</Link>.
      </p>
    </Notification>
  );
}

export function passwordResetLimitError(authError: AuthError, className = '') {
  return (
    <Notification type="danger" title={authError.title!} className={className}>
      <p>
        {authError.message +
          ' ' +
          l10n.t(
            'ErrorNotifications:resetLimit',
            'For additional help resetting your password, contact '
          )}
        <Link to="mailto:support@getbuilt.com"> support@getbuilt.com</Link>.
      </p>
    </Notification>
  );
}



// WEBPACK FOOTER //
// ./src/components/ErrorNotifications.tsx